import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-radio-config',
  templateUrl: './d-radio-config.component.html',
  styles: []
})
export class DRadioConfigComponent extends DynamicComponentBase {
  static KEY = 'd-radio-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}

  addRow() {
    const newRow = {
      value: '',
      label: ''
    };
    this.config.dataSource = [...this.config.dataSource, newRow];
  }
  deleteRow(i) {
    this.config.dataSource.splice(i, 1);
  }
}
